/**
 * Configure a page to hijack user typing for fields that are annotated with
 * the HTML class js-typing-hijack (or any overridden class of choice) such
 * that they do not allow those characters to be typed, and also to optionally
 * notify the user of the restriction upon invalid input.
 *
 */

export default class TypingHijack {
  /**
   * @constructor
   * @param {Object} [options]
   * @param {object} [options.regex] - RegExp object used to match allowed characters
   * @param {string} [options.selector] - CSS selector used to match fields when binding hijacked events
   * @param {boolean} [options.toastOnInvalid=true] - Send a toast as to why input was invalid.
   * @param {string} [options.invalidText] - Text to display when toasting invalid input.
   */
  constructor(options = {}) {
    // default hijack is letters, numbers, period.
    this.regex = options.regex || /[A-Z0-9\.\s]/i;
    this.selector = options.selector || ".js-typing-hijack";
    this.toastOnInvalid = options.toast === undefined ? true : options.toast;
    this.invalidText = options.invalidText || "The only characters that can be used in this form are letters (A-Z), numbers (0-9), period (.)";

    this.bindHijackHandlers();
  }

  // Bind handlers to keypress and paste to hijack user inputs
  // into restricted input fields.
  bindHijackHandlers() {
    N2.handle("keypress", this.selector, (evt) => {
      let keyChar = String.fromCharCode(evt.keyCode);

      return this.validateInput(keyChar, evt);
    });

    N2.handle("paste", this.selector, (evt) => {
      let pastedStr = evt.originalEvent.clipboardData.getData("text");

      return this.validateInput(pastedStr, evt);
    });
  }

  // Check passted string against configured regex, if it fails
  // then cancel the event (keypress, paste) and send the user a
  // toast about invalid input.
  validateInput(inputStr, evt) {
    let valid = this.validStringCheck(inputStr);

    if (!valid) {
      if (this.toastOnInvalid) {
        this.toastInvalid();
      }
      evt.preventDefault();
    }

    return valid;
  }

  // Check a passed string for validity against configured
  // regex. Generic version that handles both single characters
  // and longer strings (for keypress and paste support).
  validStringCheck(str) {
    let valid = true;
    $.each(str.split(''), (ix, c) => {
      valid = valid && this.regex.test(c);
    });
    return valid;
  }

  toastInvalid() {
    new N2Styles.toast(this.invalidText);
  }
}
